export const GET_BEACH_SWING_AND_TRADES =
  '/api/BeachSwingAndTrade/BeachSwingAndTradeByDate';
export const GET_BEACH_SWING_AND_TRADES_BY_DATE_RANGE =
  '/api/BeachSwingAndTrade/BeachSwingAndTradeByDateRange';
export const DOWNLOAD_BEACH_SWING_AND_TRADES =
  '/api/BeachSwingAndTrade/Download';
export const DOWNLOAD_BEACH_SWING_AND_TRADES_BY_DATE_RANGE =
  '/api/BeachSwingAndTrade/DownloadByDateRange';
